import axios from 'axios';

export default axios.create({
    baseURL: "http://game-portal.ap-northeast-2.elasticbeanstalk.com",
});